import { HStack, Spacer, VStack, XButton, XImage, XText } from "IZOX/_X";
import { ColorX, GState, LocaleX, ZMath } from "IZOX/STATIC";
import { observer } from "mobx-react";
import LangSW from "./LangSW";
import { useCallback } from "react";

function MenuM({
  history, 
  toPage
}){

  const renderPageBtn = useCallback((caption, page, range) => {
    let {location} = history ?? {};
    let {pathname} = location ?? {};
    let isCurrentPage = pathname === page;
    let isInRange = false;

    if(pathname.includes("Home")){
      isInRange = ZMath.IsBetween(GState.indexScroll, range?.min, range?.max);
    }

    return (
      <XButton height={50}
        color={ColorX.CSS(isCurrentPage || (GState.menuClick === "" && isInRange) || GState.menuClick === page ? "Axit" : "Stone")}
        onPress={() => {
          toPage?.(page);
          GState.setMini(false);
        }}>
        <XText fontSize={16} textAlign="[">
          {LocaleX.Parse(caption)}
        </XText>
      </XButton>
    );
  }, [history, toPage]);

  const renderContactUs = () => {
    return (
      <XButton onPress={() => {
        toPage?.("/ContactUs");
        GState.setMini(false);
      }}
        bgColor={ColorX.CSS("Axit")} round={50} fullWidth
        color={ColorX.CSS("pureWhite")}>
        <HStack spacing={10} pH={12} pV={2}>
          <XImage source="/Images/Icons/mphone.png" noResize width={24} height={24}/>
          <XText fontSize={16} color={ColorX.CSS("pureWhite")} bold>
            {LocaleX.Parse({
              EN: "Contact Us",
              TC: "聯絡我們"
            })}
          </XText>
        </HStack>
      </XButton>
    );
  };

  const renderLineBreak = () => {
    return (
      <HStack bgColor={ColorX.CSS("lightGrey")} height={1} width={"100%"} mV={8}/>
    );
  };

  return (
    <VStack position="fixed" pB={100} pH={20} pT={30} bgColor={ColorX.CSS("pureWhite")}
      top={70} left={0} fullWidth fullHeight HAlign="[" zIndex={1000}>
      {renderPageBtn({
        EN: "Services",
        TC: "服務"
      }, "/Home#services", {min: -2299, max: -1516})}
      {renderLineBreak()}
      {renderPageBtn({
        EN: "About Us",
        TC: "關於我們"
      }, "/Home#aboutus", {min: -108, max: 811})}
      {renderLineBreak()}
      {renderPageBtn({
        EN: "General Insurance",
        TC: "一般保險"
      }, "/GeneralInsurance")}
      {renderLineBreak()}
      {renderPageBtn({
        EN: "Terms and Conditions",
        TC: "條款及細則"
      }, "/TandC")}
      {renderLineBreak()}
      {renderPageBtn({
        EN: "Payment",
        TC: "支付"
      }, "/Payment")}
      <HStack mV={20}>
        <LangSW widen/>
      </HStack>
      <Spacer/>
      {renderContactUs()}
    </VStack>
  );

}

export default observer(MenuM);